import React from 'react'
import { ZdsCheckbox } from '@zera/components'
import { AlertLabel, NormalLabel, Container } from './styles'

interface ICheckboxWithLabelProps {
  label: string
  value: string
  checked: boolean
  onChange: (event: any) => void
}

export const checkboxWithLabel = (isTheReferenceValueOutOfRange: boolean) => {
  const Label = isTheReferenceValueOutOfRange ? AlertLabel : NormalLabel

  const CheckboxWithLabel = (props: ICheckboxWithLabelProps) => {
    const { label, value, checked, onChange } = props

    const handleOnChange = (event: any) => {
      const { value, checked } = event.target
      if (onChange) onChange({ value, checked })
    }
    return (
      <Container>
        <ZdsCheckbox value={value} onChange={handleOnChange} checked={checked} />
        <Label data-testid="quantitative-property-label" checked={checked}>
          {label}
        </Label>
      </Container>
    )
  }

  CheckboxWithLabel.displayName = 'CheckboxWithLabel'
  return CheckboxWithLabel
}
